import React from 'react'

import { Dashboard, PageLayout } from '@components'
import {
  BackButton,
  Banner,
  ButtonGroup,
  HeadContent,
  Loading,
  Pagination,
  ToolbarButton,
} from '@fourthwall/components'
import { DownloadIcon } from '@fourthwall/icons'
import { useQueryPage } from '@fourthwall/utils'
import { routing } from '@utils/routing'

import { TransactionsData } from './components/TransactionsData/TransactionsData'
import { useBillingReport } from './hooks/useBillingReport'
import { useBillingQuery } from './queries/useBillingQuery'

export const Transactions = () => {
  const { page, setPage } = useQueryPage()
  const { billingQuery } = useBillingQuery([{ size: 20, page: page - 1 }])
  const { billingReport } = useBillingReport()

  const title = 'Transactions history'
  const transactions = billingQuery.data?.transactions || []
  const totalPages = billingQuery.data?.page.totalPages

  return (
    <>
      <HeadContent title={`${title} \u2013 Settings`} />
      <PageLayout>
        <Dashboard.Section
          name={title}
          titleSpacing="medium"
          toolbarContent={
            <ButtonGroup>
              <Loading isLoading={billingReport.isLoading}>
                <ToolbarButton
                  label="Export"
                  icon={DownloadIcon}
                  onClick={billingReport.download}
                />
              </Loading>
            </ButtonGroup>
          }
          topContent={<BackButton label="Payouts" to={routing.settings.billing.self} />}
          bottomContent={
            transactions.length ? (
              <Banner
                title="Profits are pending while they can be canceled or changed by the supporter."
                appearance="warning"
              />
            ) : undefined
          }
        />
        <Dashboard.Section.Item>
          <TransactionsData data={transactions} isLoading={billingQuery.isLoading} />
        </Dashboard.Section.Item>
        <Dashboard.Section.Item>
          {!!totalPages && (
            <Pagination pageCount={totalPages} currentPage={page} onChange={setPage} />
          )}
        </Dashboard.Section.Item>
      </PageLayout>
    </>
  )
}
